import React, { useEffect, useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { mailServices } from "../../APIServices/GlobalManagement/mailServices";
import Swal from "sweetalert2";

const UpdateTemplate = ({
  Show,
  Hide,
  Title,
  getMailTemplateList,
  mailTemplatedata,
}) => {
  const [loader, setLoader] = useState(false);
  const [templateName, setTemplateName] = useState("");

  const updatedMailTemplate = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update Form metadata?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setLoader(true);
      const userData = {
        mailId: mailTemplatedata?.mailId,
        name : templateName,
      };
      const data = await mailServices.updatedMailTemplate(userData);
      if (data?.statusCode === 200) {
        setTemplateName("");
        getMailTemplateList();
        Hide();
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    if (mailTemplatedata) {
      setTemplateName(mailTemplatedata.name || "");
    }
  }, [mailTemplatedata]);
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Template Name
          </Form.Label>
          <Form.Control
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            placeholder="Enter Template Name"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top bg-light">
        <Button
          disabled={!templateName || loader}
          onClick={updatedMailTemplate}
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-2 py-1 px-3"
        >
          {loader ? "Saving..." : Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default UpdateTemplate;
